import { render, staticRenderFns } from "./UIComponentsDemoView.vue?vue&type=template&id=2e3ac9e3&"
import script from "./UIComponentsDemoView.vue?vue&type=script&lang=ts&"
export * from "./UIComponentsDemoView.vue?vue&type=script&lang=ts&"
import style0 from "./UIComponentsDemoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VSimpleTable})
